import { useCallback, useState } from 'react'

import { useSearchParams } from 'next/navigation'

import { PRODUCT_QUERY_PARAMS } from '@/features/navigation/constants'

export const useSearchQuery = () => {
    const searchParams = useSearchParams()
    const [query, setQuery] = useState(searchParams.get(PRODUCT_QUERY_PARAMS.SEARCH) ?? '')

    const setInitialQuery = useCallback(() => {
        const currentParamValue = searchParams.get(PRODUCT_QUERY_PARAMS.SEARCH)

        if (!currentParamValue) return

        setQuery(currentParamValue)
    }, [searchParams])

    return { query, setQuery, setInitialQuery }
}
